{
  "wysiwyg.viewer.components.HorizontalMenu": [
    "wysiwyg.viewer.skins.menu.TextOnlyMenuSkin",
    "wysiwyg.viewer.skins.menu.TextSeparatorsMenuSkin",
    "wysiwyg.viewer.skins.menu.SolidColorMenuSkin",
    "wysiwyg.viewer.skins.menu.ShinyMenuISkin",
    "wysiwyg.viewer.skins.menu.ShinyMenuIISkin",
    "wysiwyg.viewer.skins.menu.OverlineMenuSkin",
    "wysiwyg.viewer.skins.menu.SeparateBasicMenuSkin",
    "wysiwyg.viewer.skins.menu.SeparateShinyIMenuSkin",
    "wysiwyg.viewer.skins.menu.SeparateShinyIIMenuSkin",
    "wysiwyg.viewer.skins.menu.LinesMenuSkin",
    "wysiwyg.viewer.skins.menu.SeparateLinesMenuSkin",
    "wysiwyg.viewer.skins.menu.PointerMenuSkin",
    "wysiwyg.viewer.skins.menu.RibbonsMenuSkin",
    "wysiwyg.viewer.skins.menu.IndentedMenuSkin",
    "wysiwyg.viewer.skins.menu.SeparateIndentedMenuSkin",
    "wysiwyg.viewer.skins.menu.ArrowRightMenuSkin",
    "wysiwyg.viewer.skins.menu.SloppyBorderMenuSkin"
  ],
  "wysiwyg.viewer.components.AdminLogin": [
    "wysiwyg.viewer.skins.button.AdminLoginSkin"
  ],
  "wixapps.integration.components.SelectableSliderGallery": [
    "wysiwyg.viewer.skins.galleryslider.SliderGalleryDefaultSkin",
    "wysiwyg.viewer.skins.galleryslider.SliderGalleryCircleSkin",
    "wysiwyg.viewer.skins.galleryslider.SliderGalleryNoArrow",
    "wysiwyg.viewer.skins.galleryslider.SliderGalleryIronSkin",
    "wysiwyg.viewer.skins.galleryslider.SliderGalleryScotchTapeSkin"
  ],
  "wixapps.integration.components.PaginatedGridGallery": [
    "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridDefaultSkin",
    "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridArrowsOutside",
    "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridOverlay",
    "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridRibbonArrows",
    "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridTextBottom"
  ],
  "wixapps.integration.components.Video": [
    "wysiwyg.viewer.skins.VideoSkin",
    "wysiwyg.viewer.skins.video.VideoDefault",
    "wysiwyg.viewer.skins.video.VideoSloppy",
    "wysiwyg.viewer.skins.video.VideoLiftedShadow"
  ],
  "wysiwyg.viewer.components.EbayItemBadge": [
    "wysiwyg.viewer.skins.EbayItemBadgeSkin"
  ],
  "contentGallery": [
    "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridNoDetail"
  ],
  "productGallery": [
    "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridSimple"
  ],
  "hoverGallery": [
    "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridNoBG"
  ],
  "wysiwyg.viewer.components.TableComponent": [
    "wysiwyg.viewer.skins.table.TableComponentDefaultSkin"
  ],
  "wysiwyg.viewer.components.inputs.NumberInput": [
    "wysiwyg.viewer.skins.input.NumberInputSkin"
  ],
  "ecomAddProduct": [
    "wysiwyg.viewer.skins.button.AddProductButton",
    "wysiwyg.viewer.skins.button.BasicButton",
    "wysiwyg.viewer.skins.button.ButtonThreeD",
    "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
    "wysiwyg.viewer.skins.button.ShinyButtonInverted",
    "wysiwyg.viewer.skins.button.ButtonArrow",
    "wysiwyg.viewer.skins.button.ButtonInnerShadow",
    "wysiwyg.viewer.skins.button.ButtonShadowRight",
    "wysiwyg.viewer.skins.button.ButtonShadowLeft",
    "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
    "wysiwyg.viewer.skins.button.ShinyButtonISkin",
    "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
    "wysiwyg.viewer.skins.button.RibbonButton",
    "wysiwyg.viewer.skins.button.CircleButton",
    "wysiwyg.viewer.skins.button.SloopyButton",
    "wysiwyg.viewer.skins.button.IronButton",
    "wysiwyg.viewer.skins.button.GamingButton",
    "wysiwyg.viewer.skins.button.ScotchTapeButton"
  ],
  "ecomApplyCoupon": [
    "wysiwyg.viewer.skins.button.ApplyButtonEcom",
    "wysiwyg.viewer.skins.button.BasicButton",
    "wysiwyg.viewer.skins.button.ButtonThreeD",
    "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
    "wysiwyg.viewer.skins.button.ShinyButtonInverted",
    "wysiwyg.viewer.skins.button.ButtonArrow",
    "wysiwyg.viewer.skins.button.ButtonInnerShadow",
    "wysiwyg.viewer.skins.button.ButtonShadowRight",
    "wysiwyg.viewer.skins.button.ButtonShadowLeft",
    "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
    "wysiwyg.viewer.skins.button.ShinyButtonISkin",
    "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
    "wysiwyg.viewer.skins.button.RibbonButton",
    "wysiwyg.viewer.skins.button.CircleButton",
    "wysiwyg.viewer.skins.button.SloopyButton",
    "wysiwyg.viewer.skins.button.IronButton",
    "wysiwyg.viewer.skins.button.GamingButton",
    "wysiwyg.viewer.skins.button.ScotchTapeButton"
  ],
  "ecomRemoveFromCart": [
    "wysiwyg.viewer.skins.button.FixedFontButton"
  ],
  "ecomViewCart": [
    "wysiwyg.viewer.skins.button.BasicButton",
    "wysiwyg.viewer.skins.button.ButtonThreeD",
    "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
    "wysiwyg.viewer.skins.button.ShinyButtonInverted",
    "wysiwyg.viewer.skins.button.ButtonArrow",
    "wysiwyg.viewer.skins.button.ButtonInnerShadow",
    "wysiwyg.viewer.skins.button.ButtonShadowRight",
    "wysiwyg.viewer.skins.button.ButtonShadowLeft",
    "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
    "wysiwyg.viewer.skins.button.ShinyButtonISkin",
    "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
    "wysiwyg.viewer.skins.button.RibbonButton",
    "wysiwyg.viewer.skins.button.CircleButton",
    "wysiwyg.viewer.skins.button.SloopyButton",
    "wysiwyg.viewer.skins.button.IronButton",
    "wysiwyg.viewer.skins.button.GamingButton",
    "wysiwyg.viewer.skins.button.ScotchTapeButton"
  ],
  "ecomCheckout": [
    "wysiwyg.viewer.skins.button.BasicButton",
    "wysiwyg.viewer.skins.button.ButtonThreeD",
    "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
    "wysiwyg.viewer.skins.button.ShinyButtonInverted",
    "wysiwyg.viewer.skins.button.ButtonArrow",
    "wysiwyg.viewer.skins.button.ButtonInnerShadow",
    "wysiwyg.viewer.skins.button.ButtonShadowRight",
    "wysiwyg.viewer.skins.button.ButtonShadowLeft",
    "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
    "wysiwyg.viewer.skins.button.ShinyButtonISkin",
    "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
    "wysiwyg.viewer.skins.button.RibbonButton",
    "wysiwyg.viewer.skins.button.CircleButton",
    "wysiwyg.viewer.skins.button.SloopyButton",
    "wysiwyg.viewer.skins.button.DisabledLayerButton",
    "wysiwyg.viewer.skins.button.IronButton",
    "wysiwyg.viewer.skins.button.GamingButton",
    "wysiwyg.viewer.skins.button.ScotchTapeButton"
  ],
  "ecomAddToCart": [
    "wysiwyg.viewer.skins.button.BasicButton",
    "wysiwyg.viewer.skins.button.ButtonThreeD",
    "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
    "wysiwyg.viewer.skins.button.ShinyButtonInverted",
    "wysiwyg.viewer.skins.button.ButtonArrow",
    "wysiwyg.viewer.skins.button.ButtonInnerShadow",
    "wysiwyg.viewer.skins.button.ButtonShadowRight",
    "wysiwyg.viewer.skins.button.ButtonShadowLeft",
    "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
    "wysiwyg.viewer.skins.button.ShinyButtonISkin",
    "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
    "wysiwyg.viewer.skins.button.RibbonButton",
    "wysiwyg.viewer.skins.button.CircleButton",
    "wysiwyg.viewer.skins.button.SloopyButton",
    "wysiwyg.viewer.skins.button.IronButton",
    "wysiwyg.viewer.skins.button.GamingButton",
    "wysiwyg.viewer.skins.button.ScotchTapeButton"
  ],
  "ecomCouponBox": [
    "wysiwyg.viewer.skins.apps.DefaultBoxSkin",
    "wysiwyg.viewer.skins.area.RectangleArea",
    "wysiwyg.viewer.skins.area.AppleArea",
    "wysiwyg.viewer.skins.area.CircleArea",
    "wysiwyg.viewer.skins.area.ThreeDeeAreaSkin",
    "wysiwyg.viewer.skins.area.LiftedShadowArea",
    "wysiwyg.viewer.skins.area.LiftedTopAreaSkin",
    "wysiwyg.viewer.skins.area.LiftedBottomAreaSkin",
    "wysiwyg.viewer.skins.area.InnerShadowAreaSkin",
    "wysiwyg.viewer.skins.area.SloopyArea",
    "wysiwyg.viewer.skins.area.BorderDashDefaultAreaSkin",
    "wysiwyg.viewer.skins.area.DBDefaultAreaSkin",
    "wysiwyg.viewer.skins.area.IronBox",
    "wysiwyg.viewer.skins.area.PhotoArea",
    "skins.viewer.area.ScotchTopArea",
    "skins.viewer.area.ScotchDoubleHorizontalArea",
    "skins.viewer.area.ScotchDoubleVerticalArea"
  ],
  "ecomCartHeader": [
    "wysiwyg.viewer.skins.apps.DefaultBoxSkin",
    "wysiwyg.viewer.skins.area.RectangleArea",
    "wysiwyg.viewer.skins.area.AppleArea",
    "wysiwyg.viewer.skins.area.CircleArea",
    "wysiwyg.viewer.skins.area.ThreeDeeAreaSkin",
    "wysiwyg.viewer.skins.area.LiftedShadowArea",
    "wysiwyg.viewer.skins.area.LiftedTopAreaSkin",
    "wysiwyg.viewer.skins.area.LiftedBottomAreaSkin",
    "wysiwyg.viewer.skins.area.InnerShadowAreaSkin",
    "wysiwyg.viewer.skins.area.SloopyArea",
    "wysiwyg.viewer.skins.area.BorderDashDefaultAreaSkin",
    "wysiwyg.viewer.skins.area.DBDefaultAreaSkin",
    "wysiwyg.viewer.skins.area.IronBox",
    "wysiwyg.viewer.skins.area.PhotoArea",
    "skins.viewer.area.ScotchTopArea",
    "skins.viewer.area.ScotchDoubleHorizontalArea",
    "skins.viewer.area.ScotchDoubleVerticalArea"
  ],
  "ecomEmptyCartBG": [
    "wysiwyg.viewer.skins.apps.DefaultBoxSkin",
    "wysiwyg.viewer.skins.area.RectangleArea",
    "wysiwyg.viewer.skins.area.AppleArea",
    "wysiwyg.viewer.skins.area.CircleArea",
    "wysiwyg.viewer.skins.area.ThreeDeeAreaSkin",
    "wysiwyg.viewer.skins.area.LiftedShadowArea",
    "wysiwyg.viewer.skins.area.LiftedTopAreaSkin",
    "wysiwyg.viewer.skins.area.LiftedBottomAreaSkin",
    "wysiwyg.viewer.skins.area.InnerShadowAreaSkin",
    "wysiwyg.viewer.skins.area.SloopyArea",
    "wysiwyg.viewer.skins.area.BorderDashDefaultAreaSkin",
    "wysiwyg.viewer.skins.area.DBDefaultAreaSkin",
    "wysiwyg.viewer.skins.area.IronBox",
    "wysiwyg.viewer.skins.area.PhotoArea",
    "skins.viewer.area.ScotchTopArea",
    "skins.viewer.area.ScotchDoubleHorizontalArea",
    "skins.viewer.area.ScotchDoubleVerticalArea"
  ],
  "ecomTextInput": [
    "wysiwyg.viewer.skins.appinputs.EcomTextInputSkin"
  ],
  "ecomShippingComboBox": [
    "wysiwyg.viewer.skins.appinputs.EcomComboBoxInputSkin"
  ],
  "ecomFeedbackCheckout": [
    "wysiwyg.viewer.skins.button.AddProductButton",
    "wysiwyg.viewer.skins.button.BasicButton",
    "wysiwyg.viewer.skins.button.ButtonThreeD",
    "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
    "wysiwyg.viewer.skins.button.ShinyButtonInverted",
    "wysiwyg.viewer.skins.button.ButtonArrow",
    "wysiwyg.viewer.skins.button.ButtonInnerShadow",
    "wysiwyg.viewer.skins.button.ButtonShadowRight",
    "wysiwyg.viewer.skins.button.ButtonShadowLeft",
    "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
    "wysiwyg.viewer.skins.button.ShinyButtonISkin",
    "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
    "wysiwyg.viewer.skins.button.RibbonButton",
    "wysiwyg.viewer.skins.button.CircleButton",
    "wysiwyg.viewer.skins.button.SloopyButton",
    "wysiwyg.viewer.skins.button.IronButton"
  ],
  "ecomFeedbackContinueShopping": [
    "wysiwyg.viewer.skins.button.AddProductButton",
    "wysiwyg.viewer.skins.button.BasicButton",
    "wysiwyg.viewer.skins.button.ButtonThreeD",
    "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
    "wysiwyg.viewer.skins.button.ShinyButtonInverted",
    "wysiwyg.viewer.skins.button.ButtonArrow",
    "wysiwyg.viewer.skins.button.ButtonInnerShadow",
    "wysiwyg.viewer.skins.button.ButtonShadowRight",
    "wysiwyg.viewer.skins.button.ButtonShadowLeft",
    "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
    "wysiwyg.viewer.skins.button.ShinyButtonISkin",
    "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
    "wysiwyg.viewer.skins.button.RibbonButton",
    "wysiwyg.viewer.skins.button.CircleButton",
    "wysiwyg.viewer.skins.button.SloopyButton",
    "wysiwyg.viewer.skins.button.IronButton"
  ],
  "ecomFeedbackContinueShopping2": [
    "wysiwyg.viewer.skins.button.AddProductButton",
    "wysiwyg.viewer.skins.button.BasicButton",
    "wysiwyg.viewer.skins.button.ButtonThreeD",
    "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
    "wysiwyg.viewer.skins.button.ShinyButtonInverted",
    "wysiwyg.viewer.skins.button.ButtonArrow",
    "wysiwyg.viewer.skins.button.ButtonInnerShadow",
    "wysiwyg.viewer.skins.button.ButtonShadowRight",
    "wysiwyg.viewer.skins.button.ButtonShadowLeft",
    "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
    "wysiwyg.viewer.skins.button.ShinyButtonISkin",
    "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
    "wysiwyg.viewer.skins.button.RibbonButton",
    "wysiwyg.viewer.skins.button.CircleButton",
    "wysiwyg.viewer.skins.button.SloopyButton",
    "wysiwyg.viewer.skins.button.IronButton"
  ],
  "wixapps.integration.components.HorizontalRepeater": [
    "wysiwyg.viewer.skins.VerticalRepeaterEmptySkin",
    "wysiwyg.viewer.skins.VerticalRepeaterSkin"
  ],
  "wysiwyg.viewer.components.inputs.RadioGroupInput": [
    "wysiwyg.viewer.skins.input.RadioGroupInputSkin"
  ],
  "wixapps.integration.components.inputs.CheckBoxGroupInput": [
    "wysiwyg.viewer.skins.input.CheckBoxGroupInputSkin"
  ],
  "tpa.viewer.components.TPAComponent": [
    "tpa.viewer.skins.TPAWidgetSkin"
  ],
  "blogPostListBoxStyle": [
    "wysiwyg.viewer.skins.area.DefaultAreaSkin",
    "wysiwyg.viewer.skins.area.RectangleArea",
    "wysiwyg.viewer.skins.area.AppleArea",
    "wysiwyg.viewer.skins.area.CircleArea",
    "wysiwyg.viewer.skins.area.BubbleArea",
    "wysiwyg.viewer.skins.area.BubbleLeftArea",
    "wysiwyg.viewer.skins.area.RibbonAreaSkin",
    "wysiwyg.viewer.skins.area.ThreeDeeAreaSkin",
    "wysiwyg.viewer.skins.area.LiftedShadowArea",
    "wysiwyg.viewer.skins.area.LiftedTopAreaSkin",
    "wysiwyg.viewer.skins.area.LiftedBottomAreaSkin",
    "wysiwyg.viewer.skins.area.InnerShadowAreaSkin",
    "wysiwyg.viewer.skins.area.SloopyArea",
    "wysiwyg.viewer.skins.area.BorderDashDefaultAreaSkin",
    "wysiwyg.viewer.skins.area.VerticalRibbonArea",
    "wysiwyg.viewer.skins.area.ArrowRightRibbon",
    "wysiwyg.viewer.skins.area.VerticalArrowArea",
    "wysiwyg.viewer.skins.area.SandClockArea",
    "wysiwyg.viewer.skins.area.DBDefaultAreaSkin",
    "wysiwyg.viewer.skins.area.BubbleAreaLeft",
    "wysiwyg.viewer.skins.area.LeftTriangleArea",
    "wysiwyg.viewer.skins.area.RightTriangleArea",
    "wysiwyg.viewer.skins.area.BubbleAreaRight",
    "wysiwyg.viewer.skins.area.IronBox",
    "wysiwyg.viewer.skins.area.PhotoArea",
    "skins.viewer.area.ScotchTopAre a",
    "skins.viewer.area.ScotchDoubleHorizontalArea",
    "skins.viewer.area.ScotchDoubleVerticalArea"
  ],
  "wysiwyg.viewer.components.Calendar": [
    "wysiwyg.viewer.skins.CalendarDefaultSkin",
    "wysiwyg.viewer.skins.CalendarTextBetweenNavSkin",
    "wysiwyg.viewer.skins.CalendarTextYearNavSkin"
  ],
  "wysiwyg.viewer.components.Month": [
    "wysiwyg.viewer.skins.MonthDefaultSkin"
  ],
  "wysiwyg.viewer.components.Day": [
    "wysiwyg.viewer.skins.DayDefaultSkin"
  ],
  "wysiwyg.viewer.components.LanguageButton": [
    "wysiwyg.viewer.skins.LanguageButtonSkin"
  ],
  "wysiwyg.viewer.components.inputs.TextInput": [
    "wysiwyg.viewer.skins.appinputs.AppsTextInputSkin"
  ]
}
